export function setloading(state, value) {
    state.loading.module = value;
}
export function setFile(state, value) {
    state.file = value;
}



// WEBPACK FOOTER //
// ./src/modules/import-products/mutations.js